'use strict';

exports = module.exports = {
  // List of user roles
  userRoles: ['guest', 'demo', 'user', 'admin'],
  layoutTypes: [
    { name: 'box-light', label: 'FB LIGHT' },
    { name: 'box-basic', label: 'FB Basic' },
    { name: 'box-premium', label: 'FB Premium' },
    { name: 'photo-mirror', label: 'Fotospiegel' },
    { name: 'booth', label: 'Fotoautomat' },
    { name: 'car', label: 'Fotomobil' }
  ]
};



//////////////////
// WEBPACK FOOTER
// ./server/config/environment/shared.js
// module id = 239
// module chunks = 0